import React, { useEffect, useState } from 'react';
import { Star } from 'lucide-react';
import { trackAddToCart } from '../hooks/useMetaPixel';
export function PricingSection() {
  const [viewers, setViewers] = useState(100);
  useEffect(() => {
    const startViewerCount = () => {
      let count = Math.floor(Math.random() * (120 - 80 + 1) + 80);
      setViewers(count);
      const interval = setInterval(() => {
        let increment = Math.floor(Math.random() * 3) - 1;
        count += increment;
        if (count < 60) count = 60;
        setViewers(count);
      }, 4500);
      return interval;
    };
    const interval = startViewerCount();
    return () => clearInterval(interval);
  }, []);
  return <section className="bg-[#111827] text-white py-[40px] px-[15px]" id="get-the-method" data-id="element-196">
      <div className="container max-w-[1200px] mx-auto px-[15px]" data-id="element-197">
        <h2 className="text-[24px] text-center mb-[20px] font-[700] text-white font-['Montserrat']" data-id="element-198">
          Get the Special Offer Today
        </h2>
        <p className="text-center text-white mx-auto mb-[30px] max-w-[600px]" data-id="element-199">
          If your knee has been shrinking your world, start here.
        </p>

        <div className="flex justify-center max-w-[550px] mx-auto mt-[20px]" data-id="element-200">
          <div className="border-[2px] border-[#DC2626] bg-gradient-to-br from-[#1f2937] to-[#000] p-[20px] rounded-[12px] text-center w-full" data-id="element-201">
            <div className="bg-gradient-to-br from-[#DC2626] to-[#FCA5A5] text-white px-[20px] py-[6px] rounded-[50px] font-bold text-[13px] uppercase mb-[15px] inline-block" data-id="element-202">
              <Star className="inline w-[13px] h-[13px] mr-1" data-id="element-203" /> LIMITED OFFER
            </div>
            <h3 className="text-[24px] text-white font-[700] font-['Montserrat']" data-id="element-204">
              The Knee Geometry Method — 15-Day Plan
            </h3>
            <p className="text-[#ddd]" data-id="element-205">Complete system</p>

            <div className="my-[12px]" data-id="element-206">
              <div className="text-[18px] line-through text-[#aaa]" data-id="element-207">$19.99</div>
              <div className="text-[44px] text-white font-[800]" data-id="element-208">$6.99 USD</div>
            </div>

            <a href="https://oriammarketing.com/cart/45536364036294:1" onClick={e => {
            e.preventDefault();
            trackAddToCart();
            setTimeout(() => {
              window.location.href = 'https://oriammarketing.com/cart/45536364036294:1';
            }, 300);
          }} className="block w-full bg-gradient-to-br from-[#DC2626] to-[#EF4444] text-white border-none p-[16px] text-[18px] font-[700] rounded-[50px] cursor-pointer shadow-[0_8px_20px_rgba(220,38,38,0.3)] text-center no-underline uppercase font-['Montserrat'] animate-pulse-custom hover:transform hover:-translate-y-[3px] hover:scale-[1.02] hover:shadow-[0_8px_20px_rgba(220,38,38,0.5)] transition-all duration-400" data-id="element-209">
              👉 DOWNLOAD NOW
            </a>
          </div>
        </div>

        <div className="max-w-[500px] mx-auto mt-[25px] mb-[10px] flex flex-col gap-[12px]" data-id="element-210">
          <div className="bg-[#111827] text-white font-[700] p-[12px] rounded-[8px] text-[16px] text-center" data-id="element-211">
            <strong data-id="element-212">
              <span className="viewer-count" data-id="element-213">{viewers}</span> people
            </strong>{' '}
            are viewing this offer
          </div>
          <div className="bg-gradient-to-br from-[#EF4444] to-[#be123c] text-white font-[700] p-[12px] rounded-[8px] text-[16px] text-center flex items-center justify-center gap-[10px]" data-id="element-214">
            <span className="w-[12px] h-[12px] bg-white rounded-full animate-pulse-red" data-id="element-215"></span>{' '}
            Last <strong data-id="element-216">5 spots</strong> at this price!
          </div>
        </div>

        <div className="text-center mt-[30px] text-[#ccc] text-[13px]" data-id="element-217">
          <p data-id="element-218">
            🔐 100% Secure Payment · ⚡ Instant access
            <br data-id="element-219" />
            💰 No hidden charges · ⏰ Limited offer
          </p>
        </div>

        <div className="mt-[20px] text-center" data-id="element-220">
          <div className="flex items-center justify-center gap-[6px] flex-wrap" data-id="element-221">
            {/* Visa */}
            <div className="bg-white rounded-[4px] px-[8px] py-[4px] shadow-sm flex items-center justify-center h-[30px] w-[48px]" data-id="element-222">
              <svg viewBox="0 0 48 32" className="h-[18px]" fill="none" data-id="element-223">
                <rect width="48" height="32" rx="4" fill="#fff" data-id="element-224" />
                <path d="M19.5 21h-3l1.9-11.5h3L19.5 21zm12.3-11.2c-.6-.2-1.5-.5-2.7-.5-3 0-5.1 1.5-5.1 3.7 0 1.6 1.5 2.5 2.6 3.1 1.2.6 1.6.9 1.6 1.4 0 .8-.9 1.1-1.8 1.1-1.2 0-1.9-.2-2.9-.6l-.4-.2-.4 2.5c.7.3 2.1.6 3.5.6 3.2 0 5.2-1.5 5.2-3.8 0-1.3-.8-2.2-2.5-3-1-.5-1.7-.9-1.7-1.4 0-.5.5-1 1.7-1 1 0 1.7.2 2.2.4l.3.1.4-2.4zm7.9-.3h-2.3c-.7 0-1.3.2-1.6.9L31.5 21h3.2l.6-1.7h3.9l.4 1.7H42L39.7 9.5zm-3.3 8.2l1.2-3.2.4-1.1.2 1 .7 3.3h-2.5zM16.2 9.5L13.3 17l-.3-1.5c-.5-1.8-2.2-3.8-4.1-4.8l2.7 10.2h3.2l4.8-11.4h-3.4z" fill="#1A1F71" data-id="element-225" />
                <path d="M10.5 9.5H5.6l-.1.3c3.8.9 6.3 3.2 7.3 5.9l-1.1-5.3c-.2-.7-.7-.9-1.2-.9z" fill="#F9A533" data-id="element-226" />
              </svg>
            </div>
            {/* Mastercard */}
            <div className="bg-white rounded-[4px] px-[8px] py-[4px] shadow-sm flex items-center justify-center h-[30px] w-[48px]" data-id="element-227">
              <svg viewBox="0 0 48 32" className="h-[18px]" fill="none" data-id="element-228">
                <circle cx="19" cy="16" r="9" fill="#EB001B" data-id="element-229" />
                <circle cx="29" cy="16" r="9" fill="#F79E1B" data-id="element-230" />
                <path d="M24 9.3a9 9 0 0 1 3.3 6.7A9 9 0 0 1 24 22.7 9 9 0 0 1 20.7 16 9 9 0 0 1 24 9.3z" fill="#FF5F00" data-id="element-231" />
              </svg>
            </div>
            {/* PayPal */}
            <div className="bg-white rounded-[4px] px-[8px] py-[4px] shadow-sm flex items-center justify-center h-[30px] w-[48px]" data-id="element-232">
              <svg viewBox="0 0 48 32" className="h-[16px]" fill="none" data-id="element-233">
                <path d="M17.5 25.5h-3.2l.2-1.2 2-12.8h4.8c2.5 0 4 1.3 3.6 3.5-.5 2.8-2.7 4.3-5.3 4.3h-1.8l-.3 1.7v.2l-.6 3.5-.1.5-.1.3zm3.2-12l-1.4 8.5h1.3c1.8 0 3.3-1 3.6-3 .3-1.5-.5-2.5-2.2-2.5h-1.3z" fill="#003087" data-id="element-234" />
                <path d="M30.5 14.5c-.4 2.8-2.7 4.3-5.3 4.3h-1.3l-.8 5.2-.1.5h-2.5l.1-.5.1-.5.8-5.2h1.3c2.6 0 4.9-1.5 5.3-4.3.1-.5.1-1 0-1.5.5.5.7 1.2.4 2z" fill="#0070E0" data-id="element-235" />
              </svg>
            </div>
            {/* Apple Pay */}
            <div className="bg-white rounded-[4px] px-[8px] py-[4px] shadow-sm flex items-center justify-center h-[30px] w-[48px]" data-id="element-236">
              <svg viewBox="0 0 48 32" className="h-[16px]" fill="none" data-id="element-237">
                <path d="M15.2 10.5c-.5.6-1.3 1-2 1-.1-.8.3-1.6.7-2.1.5-.6 1.3-1 2-1 .1.8-.2 1.5-.7 2.1zm.7 1.1c-1.1-.1-2.1.6-2.6.6s-1.4-.6-2.3-.6c-1.2 0-2.3.7-2.9 1.8-1.2 2.1-.3 5.3.9 7 .6.9 1.3 1.8 2.2 1.8.9 0 1.2-.6 2.3-.6 1 0 1.3.6 2.3.6.9 0 1.6-.9 2.2-1.8.7-1 .9-2 .9-2-.1 0-1.8-.7-1.8-2.7 0-1.7 1.4-2.5 1.5-2.6-.8-1.2-2.1-1.4-2.6-1.4l-.1-.1z" fill="#000" data-id="element-238" />
                <path d="M24.5 9.5v12h1.8v-4.1h2.5c2.3 0 3.9-1.6 3.9-3.9s-1.6-4-3.9-4h-4.3zm1.8 1.5h2.1c1.6 0 2.5.8 2.5 2.4s-.9 2.5-2.5 2.5h-2.1V11zm10.4 10.6c1.1 0 2.2-.6 2.7-1.5h0v1.4h1.7V16c0-1.7-1.4-2.8-3.4-2.8-1.9 0-3.3 1.1-3.3 2.7h1.6c.1-.8.8-1.3 1.7-1.3 1.1 0 1.7.5 1.7 1.4v.6l-2.2.1c-2.1.1-3.2 1-3.2 2.4 0 1.5 1.1 2.5 2.7 2.5zm.5-1.4c-1 0-1.6-.5-1.6-1.2 0-.8.6-1.2 1.8-1.3l2-.1v.6c0 1.1-1 2-2.2 2z" fill="#000" data-id="element-239" />
              </svg>
            </div>
            {/* Google Pay */}
            <div className="bg-white rounded-[4px] px-[8px] py-[4px] shadow-sm flex items-center justify-center h-[30px] w-[48px]" data-id="element-240">
              <svg viewBox="0 0 48 32" className="h-[16px]" fill="none" data-id="element-241">
                <path d="M22.8 16.2v4.3h-1.4V10h3.7c.9 0 1.7.3 2.3.9.7.6 1 1.3 1 2.2 0 .9-.3 1.6-1 2.2-.6.6-1.4.9-2.3.9h-2.3zm0-4.9v3.6h2.3c.5 0 1-.2 1.4-.6.4-.4.5-.8.5-1.2 0-.5-.2-.9-.5-1.2-.4-.4-.8-.6-1.4-.6h-2.3z" fill="#5F6368" data-id="element-242" />
                <path d="M31.2 13.3c1 0 1.8.3 2.4.8.6.6.9 1.3.9 2.3v4.1h-1.3v-.9c-.5.8-1.2 1.1-2.2 1.1-.8 0-1.5-.2-2-.7-.5-.5-.8-1-.8-1.7 0-.7.3-1.3.8-1.7.5-.4 1.3-.7 2.2-.7.8 0 1.4.2 1.9.5v-.4c0-.5-.2-1-.6-1.3-.4-.3-.8-.5-1.3-.5-.8 0-1.4.3-1.8 1l-1.2-.7c.6-1 1.5-1.5 2.8-1.5l.2.3zm-1.7 5.5c0 .4.2.7.5.9.3.2.7.4 1.1.4.6 0 1.1-.2 1.6-.7.5-.5.7-1 .7-1.6-.4-.4-1-.5-1.8-.5-.6 0-1 .1-1.4.4-.5.3-.7.6-.7 1.1z" fill="#5F6368" data-id="element-243" />
                <path d="M42 13.5l-4.5 10.3h-1.4l1.7-3.6-3-6.7h1.5l2.1 5.1 2.1-5.1H42z" fill="#5F6368" data-id="element-244" />
                <path d="M16.2 15.8c0-.4 0-.8-.1-1.2h-5.7v2.2h3.3c-.1.8-.5 1.4-1.1 1.8v1.5h1.8c1.1-1 1.7-2.4 1.8-4.3z" fill="#4285F4" data-id="element-245" />
                <path d="M10.4 20.6c1.5 0 2.8-.5 3.7-1.4l-1.8-1.4c-.5.3-1.1.5-1.9.5-1.5 0-2.7-1-3.1-2.3H5.4v1.5c.9 1.8 2.8 3.1 5 3.1z" fill="#34A853" data-id="element-246" />
                <path d="M7.3 16c-.1-.4-.2-.8-.2-1.2s.1-.8.2-1.2v-1.5H5.4c-.4.9-.7 1.8-.7 2.7 0 1 .2 1.9.7 2.7l1.9-1.5z" fill="#FBBC04" data-id="element-247" />
                <path d="M10.4 11.3c.8 0 1.6.3 2.1.8l1.6-1.6c-1-.9-2.3-1.5-3.7-1.5-2.2 0-4.1 1.3-5 3.1l1.9 1.5c.4-1.4 1.6-2.3 3.1-2.3z" fill="#EA4335" data-id="element-248" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </section>;
}